<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >वीडियो KYC </h2>
        </div>
        <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='22'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="23">

            <label for="" class="mt-4" >वीडियो केवाईसी (अपने ग्राहक को जानें)
                एक उन्नत और सुरक्षित सत्यापन प्रक्रिया है जिसका उपयोग पे जी द्वारा ग्राहकों
                को दूर से बोर्ड करने के लिए किया जाता है। यह ग्राहकों को व्यक्तिगत सत्यापन
                के लिए किसी शाखा या कार्यालय में जाने के बजाय वीडियो के माध्यम से अपनी
                केवाईसी आवश्यकताओं को पूरा करने की अनुमति देता है। ग्राहक को अपनी पहचान और
                प्रासंगिक दस्तावेज़ प्रस्तुत करने और सत्यापित करने की आवश्यकता होती है, जो
                आम तौर पर आधार और पैन कार्ड जैसे सरकार द्वारा जारी पहचान दस्तावेज़ होते हैं।
            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="24">
            <h2 >
                वीडियो KYC के प्रमुख लाभ
            </h2>
            <label for="" class="mt-3" >वीडियो KYC (अपने ग्राहक को जानें)
                व्यवसायों और ग्राहकों दोनों के लिए कई लाभ प्रदान करता है। यहां कुछ प्रमुख
                लाभ दिए गए हैं: </label>

            <h5 class="mt-3" >सुविधा </h5>
            <label for="" class="mt-1" >वीडियो केवाईसी ग्राहकों को अपने घर से
                या इंटरनेट कनेक्शन वाले किसी भी स्थान से केवाईसी प्रक्रिया को पूरा करने का
                एक सुविधाजनक और लचीला तरीका प्रदान करता है। </label>

            <h5 class="mt-3" >समय कौशल </h5>
            <label for="" class="mt-1" >यह पारंपरिक तरीकों की तुलना में केवाईसी
                प्रक्रिया को पूरा करने के लिए आवश्यक समय को काफी कम कर देता है, जहां
                ग्राहकों को भौतिक स्थानों पर जाने की आवश्यकता हो सकती है। </label>

            <h5 class="mt-3" >लागत बचत </h5>
            <label for="" class="mt-1" >व्यवसाय ईंट-और-मोर्टार शाखाओं जैसे
                भौतिक बुनियादी ढांचे की आवश्यकता को कम करके और केवाईसी प्रक्रिया को अनुकूलित
                करके लागत बचत प्राप्त कर सकते हैं। </label>

            <h5 class="mt-3" >सुरक्षा बढ़ाना </h5>
            <label for="" class="mt-1" >वीडियो केवाईसी वास्तविक समय में
                आमने-सामने सत्यापन की अनुमति देकर, पहचान धोखाधड़ी के जोखिम को कम करके और यह
                सुनिश्चित करके सुरक्षा बढ़ाता है कि केवाईसी से गुजरने वाला व्यक्ति शारीरिक
                रूप से मौजूद है। </label>

            <h5 class="mt-3" >प्रयोगकर्ता का अनुभव </h5>
            <label for="" class="mt-1" >वीडियो केवाईसी प्रक्रिया एक सकारात्मक
                उपयोगकर्ता अनुभव में योगदान करती है, क्योंकि ग्राहक अधिक इंटरैक्टिव और
                उपयोगकर्ता-अनुकूल इंटरफ़ेस के माध्यम से केवाईसी आवश्यकताओं को पूरा कर सकते
                हैं। </label>

            <h5 class="mt-3" >अनुपालन </h5>
            <label for="" class="mt-1" >वीडियो केवाईसी संपूर्ण और दस्तावेजी
                सत्यापन प्रक्रिया सुनिश्चित करके व्यवसायों को नियामक आवश्यकताओं के अनुरूप
                बने रहने में मदद करता है।
            </label>

            <h5 class="mt-3" >कागजी कार्रवाई कम हो गई </h5>
            <label for="" class="mt-1" >केवाईसी प्रक्रिया को डिजिटलीकरण करके,
                वीडियो केवाईसी व्यापक कागजी कार्रवाई की आवश्यकता को कम कर देता है, और अधिक
                पर्यावरण के अनुकूल और सुव्यवस्थित प्रक्रिया में योगदान देता है।
            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="25">
            <h2 >
                पे जी में वीडियो KYC प्रक्रिया में निम्नलिखित चरण शामिल हैं: 
            </h2>
            <label for="" class="mt-2" > <b> चरण 1:</b>पे जी ऐप खोलें, वीडियो KYC अनुभाग पर जाएं और अपनी पसंदीदा भाषा चुनें।  </label>
            <br> <img src="./assets/kyc 1.png" width="200px" height="800px"
                                         alt="">
            
            <br> <label for="" class="mt-2" > <b> चरण 2:</b>'मैं आपके नियमों और शर्तों से सहमत हूं' चेकबॉक्स पर क्लिक करें और "वीडियो केवाईसी प्रारंभ करें" विकल्प पर क्लिक करके वीडियो केवाईसी प्रक्रिया शुरू करें।  </label>
            <br> <img src="./assets/kyc 2.png" width="200px" height="400px"
                                         alt="">
            

            <br> <label for="" class="mt-2" > <b> चरण 3:</b> यह सुनिश्चित करने के लिए अपने कैमरे को समायोजित करें कि आपका चेहरा स्क्रीन पर स्पष्ट रूप से दिखाई दे, फिर 'वीडियो केवाईसी प्रारंभ करें' पर क्लिक करने के लिए आगे बढ़ें।  </label>
            <br> <img src="./assets/kyc 3.png" width="200px" height="400px"
                                         alt="">
            

            <br> <label for="" class="mt-2" > <b> चरण 4:</b>"I am ready" पर क्लिक करें और अपना नाम स्पष्ट रूप से कहें।  
            </label>
            <br> <img src="./assets/kyc 4.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 5.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> चरण 5:</b> फिर से "I am ready" पर क्लिक करें और अपनी कंपनी का नाम कहें। </label>
            <br> <img src="./assets/kyc 6.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 7.png" width="200px" height="400px"
                                         alt="">
            <br> <label for="" class="mt-2" > <b> चरण 6:</b> इसी तरह वीडियो में अपना आधार कार्ड दिखाएं और वीडियो में आधार नंबर जोर-जोर से पढ़ें.  </label>
            <br> <img src="./assets/kyc 8.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 9.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> चरण 7:</b> अपने पैन कार्ड को वीडियो फ्रेम में स्पष्ट रूप से प्रदर्शित करें और अपना पैन कार्ड नंबर पढ़ें। </label>
            <br> <img src="./assets/kyc 10.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 11.png" width="200px" height="400px"
                                         alt="">

            <br> <label for="" class="mt-2" > <b> चरण 8:</b> इस चरण में अपनी कंपनी के बुनियादी ढांचे की लाइव तस्वीरें क्लिक करें। 
               </label>
            <br> <img src="./assets/kyc 12.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 13.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 14.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 15.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 16.png" width="200px" height="400px"
                                         alt="">
            
            <br> <label for="" class="mt-2" > <b> चरण 9:</b> सबमिट बटन पर क्लिक करें.
               </label>
            <br> <img src="./assets/kyc 17.png" width="200px" height="400px"
                                         alt="">
            <br> <img src="./assets/kyc 18.png" width="200px" height="400px"
                                         alt="">

        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2   ">
    <div class="card crd p-4">
        <div class="row">
            <div class="col-md-12">
                <h5 >
                    विषयसूची:
                </h5>
            </div>
            <!-- <div class="col-md-12 mt-2">
            <a href="#22"> <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        What is a Video KYC? </span>
                </div>
            </div></a
        </div> -->
            <div class="col-md-12 mt-2">
                <a href="#23">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                >
                                वीडियो KYC क्या है? </span>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-12 mt-2">
                <a href="#24">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="textHover"
                                [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                >वीडियो KYC के लाभ </span>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-12 mt-2">
                <a href="#25">
                    <div class="row">
                        <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                alt="">
                            &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="textHover"
                                [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                >पे जी पर वीडियो KYC प्रक्रिया </span>
                        </div>
                    </div>
                </a>
            </div>


        </div>
    </div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
           
            <a [routerLink]="['/invoice']"> <button class="btn btn-color" (click)="menues('Invoice')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;इनवॉइस
            </button></a>
        </div>
        <div class="col-md-4   ">
            
            <a [routerLink]="['/transaction']"><button class="btn btn-color" (click)="menues('Transactions')"
                >ट्रांजेक्शन
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
        </div>
    </div>
</div>
</div>